import { FunctionComponent, useState } from "react";
import Button from "../../components/button";
import { EditorProps } from "../editor";
import SelectionsModal from "./modal";

interface InitialSelectionsFieldProps extends EditorProps {}

const InitialSelectionsField: FunctionComponent<InitialSelectionsFieldProps> = ({ configurator, setConfigurator }) => {
  const [open, setOpen] = useState(false);
  const initialSelections = configurator.options.initialSelections;
  return (
    <div className="p-6 border-b">
      <div className="font-bold mb-6 text-lg">
        Initial Selections <span className="bg-gray-200 rounded-md px-2 py-1">{initialSelections?.length ?? 0}</span>
      </div>
      <Button onClick={() => setOpen(true)} variant="secondary" className="w-full">
        Change initial selections
      </Button>
      {!open ? null : (
        <SelectionsModal
          onClose={() => setOpen(false)}
          onSave={(val) => {
            setConfigurator((prev) => (!prev ? prev : { ...prev, options: { ...prev.options, initialSelections: val } }));
            setOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default InitialSelectionsField;
